import React from "react";
import { Formik } from "formik";
import { TextField, withStyles, Button, InputLabel, FormControl, Typography, Select, MenuItem, CircularProgress } from "@material-ui/core";
import * as Yup from "yup";
import {hasPermission} from "../../sc-utilities";


const styles = theme => ({
    root: {
        width: 'auto',
        height: 'auto',
        padding: theme.spacing(2),
        margin: theme.spacing(2),
    },
    submit: {
        textTransform: 'none',
        color: theme.palette.buttonText.default,
        backgroundColor: theme.palette.primary.main,
        borderRadius: '1px',
        '&:hover': {
            backgroundColor: theme.palette.secondary.main,
        },
        width: "100%",
        marginTop: "10px"
    },
    formControl: {
        width: "100%"
    }
});

export const types = [{value: "system", displayValue: "System typical problem"}, {value: "custom", displayValue: "Customer typical problem"}];

export const updateKey = (nameValue) => {
    let key = '';
    key = nameValue.replace(/[&/\\#,+()$~%.'":*?<>{}^;`|!@-]+/g,'_').replace(/ +/g,"_").replace(/_+/g, '_').toLowerCase();
    return key;
}

const TypicalProblemForm = props => {
    const {
        classes,
        formSettings,
        initialValues,
        handleSubmit,
        translations,
        grades,
        gradingCategories,
        types,
        permissions,
        CustomerIDPreviousState,
        fromEdit
    } = props;

    return (
        <div className={classes.root}>
            <Formik
                initialValues={initialValues}
                onSubmit={async (values, {setSubmitting}) => {
                    setSubmitting(true);
                    await handleSubmit(values);
                    setSubmitting(false);
                }}
                validationSchema={Yup.object().shape(formSettings.Validation)}
            >
                {formikProps => {
                    const {
                        values,
                        touched,
                        errors,
                        isValid,
                        dirty,
                        isSubmitting,
                        handleChange,
                        handleBlur,
                        handleSubmit,
                        setFieldValue
                    } = formikProps;

                    return (
                        <form onSubmit={handleSubmit}>
                            <Typography
                                variant={"h6"}>{formSettings.FormTitle ? formSettings.FormTitle : null}</Typography>
                            <TextField
                                name="Name"
                                value={values.Name}
                                onChange={(e) => {handleChange(e); setFieldValue('Key', updateKey(e.target.value))}}
                                onBlur={handleBlur}
                                error={!!(errors.Name && touched.Name)}
                                placeholder={translations['short_name'] || 'Short name'}
                                label={translations['short_name'] || 'Short name'}
                                margin={"dense"}
                                fullWidth={true}
                            />
                            <TextField
                                name="LongName"
                                value={values.LongName}
                                onChange={handleChange}
                                onBlur={handleBlur}
                                error={!!(errors.LongName && touched.LongName)}
                                placeholder={translations['long_name'] || 'Long name'}
                                label={translations['long_name'] || 'Long name'}
                                margin={"dense"}
                                fullWidth={true}
                            />
                            <TextField
                                name="Code"
                                value={values.Code}
                                onChange={handleChange}
                                onBlur={handleBlur}
                                error={!!(errors.Code && touched.Code && errors.Code)}
                                placeholder={translations['code'] || 'Code'}
                                label={translations['code'] || 'Code'}
                                margin={"dense"}
                                fullWidth={true}
                            />
                            <FormControl className={classes.formControl} margin={"dense"}>
                                <InputLabel shrink>{translations['grade_text'] || "Please select grade"}</InputLabel>
                                <Select
                                    name="GradeID"
                                    label={translations['grading_category'] || 'Grading category'}
                                    margin={"dense"}
                                    value={values.GradeID}
                                    onChange={handleChange}
                                >
                                    {(grades ? [...grades] : []).map(option => (
                                        <MenuItem key={option.value} value={option.value}>
                                            {option.displayValue}
                                        </MenuItem>
                                    ))}
                                </Select>
                            </FormControl>
                            <FormControl className={classes.formControl} margin={"dense"}>
                                <InputLabel
                                    shrink>{translations['grading_category_text'] || "Please select grading category"}</InputLabel>
                                <Select
                                    name="GradingCategoryID"
                                    label={translations['grading_category'] || 'Grading category'}
                                    margin={"dense"}
                                    value={values?.GradingCategoryID?.toString() || ''}
                                    onChange={handleChange}
                                >
                                    {(gradingCategories ? [...gradingCategories] : []).map(option => (
                                        <MenuItem key={option.value} value={option.value.toString()}>
                                            {option.displayValue}
                                        </MenuItem>
                                    ))}
                                </Select>
                            </FormControl>
                            {hasPermission(permissions, 'system_typical_problem_create') ? (<><FormControl className={classes.formControl}
                                                                               margin={"dense"}>
                                <InputLabel
                                    shrink>{translations['typical_problem_type'] || "Please select typical problem type"}</InputLabel>
                                <Select
                                    name="CustomerID"
                                    label={translations['typical_problem_type'] || 'Please select typical problem type'}
                                    margin={"dense"}
                                    value={values?.CustomerID?.toString() || ''}
                                    onChange={handleChange}
                                    disabled={values?.CustomerID?.toString() === 'system' && fromEdit && CustomerIDPreviousState==='system'}
                                >
                                    {(types ? [...types] : []).map(option => (
                                        <MenuItem key={option.value} value={option.value.toString()}>
                                            {option.displayValue}
                                        </MenuItem>
                                    ))}
                                </Select>
                            </FormControl>
                                {values?.CustomerID?.toString() === 'system'  ? <TextField
                                    name="Key"
                                    value={values?.Key ? updateKey(values?.Key) : ''}
                                    onChange={(e) => setFieldValue('Key', updateKey(e.target.value))}
                                    onBlur={handleBlur}
                                    error={!!(errors.Key)}
                                    placeholder={translations['typical_problem_key'] || 'Key'}
                                    label={translations['typical_problem_key'] || 'Key'}
                                    margin={"dense"}
                                    fullWidth={true}
                                /> : null}
                            </>) : null}
                            <div>
                                {formSettings.ButtonSubmit ? (
                                    <Button
                                        className={classes.submit}
                                        variant="contained"
                                        color={formSettings.ButtonSubmit.Color}
                                        type="submit"
                                        disabled={isSubmitting || !(isValid && dirty)}
                                    >
                                        {isSubmitting ? <CircularProgress size={24}/> : formSettings.ButtonSubmit.Title}
                                    </Button>
                                ) : null}
                            </div>
                        </form>
                    );
                }}
            </Formik>
        </div>
    );
}

export default withStyles(styles, { withTheme: true })(TypicalProblemForm);
